module.exports = __webpack_public_path__ + "static/media/lounaan-abc.831bc7d0.jpg";